import { render, staticRenderFns } from "./RptGenerarReferenciaFacturaComponent.vue?vue&type=template&id=4073a360&"
import script from "./RptGenerarReferenciaFacturaComponent.vue?vue&type=script&lang=js&"
export * from "./RptGenerarReferenciaFacturaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports